// extracted by mini-css-extract-plugin
export default {"inputField":"InputField_inputField__XAqHW","label":"InputField_label__3buA7"};